module.exports = __webpack_public_path__ + "static/media/logo-ae.b6a97eac.png";